import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';

import Button from '@material-ui/core/Button';
import IconCancel from '@material-ui/icons/Cancel';
import withStyles from '@material-ui/core/styles/withStyles';

import {translate} from 'react-admin'; // eslint-disable-line import/no-unresolved

const onCancel = e => {
    window.history.back();
}

const styles = {
    button: {
        margin: '10px 24px',
        position: 'relative',
    },
    iconPaddingStyle: {
        paddingRight: '0.5em',
    },
};

const CancelButtonView = ({
    classes,
    label = 'ra.action.cancel',
    translate,
                              ...rest
}) => (
    <Button className={classes.button} onClick={onCancel} {...rest}>
        <IconCancel className={classes.iconPaddingStyle}/>
        {label && translate(label, {_: label})}
    </Button>
);

CancelButtonView.propTypes = {
    classes: PropTypes.object,
    label: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

export default compose(
    translate,
    withStyles(styles)
)(CancelButtonView);
